export default __webpack_public_path__ + "static/media/flag-se.7c3e2147.svg";